exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".formDelOrg .del-warning {\n  padding-bottom: 20px; }\n\n.formDelOrg .form-block {\n  margin-top: 0px; }\n\n.formDelOrg .form-action {\n  float: right; }\n\n.formDelOrg form {\n  padding-top: 0; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/app/components/dataprotection/dataprotection-vcd/delete-policy/delete-policy.scss
// module id = FUjv
// module chunks = 0